/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Tlm_3Inputs */

const en_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`throughput`)
};

const ar_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنتاجية`)
};

const bn_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`throughput`)
};

const de_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsatz`)
};

const es_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendimiento`)
};

const fr_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débit`)
};

const pt_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`taxa de transferência`)
};

const zh_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`吞吐量`)
};

const tr_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktarım hızı`)
};

const ru_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`пропускная способность`)
};

const pl_svc_automation_tlm_3 = /** @type {(inputs: Svc_Automation_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przepustowość`)
};

/**
* | output |
* | --- |
* | "throughput" |
*
* @param {Svc_Automation_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_tlm_3 = /** @type {((inputs?: Svc_Automation_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_tlm_3(inputs)
	if (locale === "bn") return bn_svc_automation_tlm_3(inputs)
	if (locale === "de") return de_svc_automation_tlm_3(inputs)
	if (locale === "es") return es_svc_automation_tlm_3(inputs)
	if (locale === "fr") return fr_svc_automation_tlm_3(inputs)
	if (locale === "pt") return pt_svc_automation_tlm_3(inputs)
	if (locale === "zh") return zh_svc_automation_tlm_3(inputs)
	if (locale === "tr") return tr_svc_automation_tlm_3(inputs)
	if (locale === "ru") return ru_svc_automation_tlm_3(inputs)
	if (locale === "pl") return pl_svc_automation_tlm_3(inputs)
	return en_svc_automation_tlm_3(inputs)
});